import type { DropdownData } from '@fitogest/reactive-form-builder/interfaces';
import { list } from '@fitogest/reactive-form-builder/utils';
import { ComunidadesRegantesModel } from 'src/app/models/analisis/comunidadesRegantes.model';
import { VisitasVariedadMesModel } from 'src/app/models/visitas_variedad_mes/visitas_variedad_mes.model';

export class PlanAbonadoListsDefinition {
    public cultivos_precedentes: DropdownData<VisitasVariedadMesModel> = list<VisitasVariedadMesModel>(['...', null]);
    
    public cultivos: DropdownData<VisitasVariedadMesModel> = list<VisitasVariedadMesModel>(['...', null]);
        
    public comunidadesRegantes: DropdownData<ComunidadesRegantesModel> = list<ComunidadesRegantesModel>();
}